module.exports = __webpack_public_path__ + "img/megamenubg.8f281bd4.jpg";